import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import useGetPlatform from "../../../hooks/usePlatform/index.js";
import { Root, Chip } from "./PrintModifierKey.components.js";
import { MAC } from "../../../constants/platform.consts.js";
export const PrintModifierKeyAtomComponent = ({ label, sx, className }) => {
    const platform = useGetPlatform();
    const modifierKey = platform === MAC ? "Cmd" : "Ctrl";
    if (!platform.trim())
        return null;
    return (_jsxs(Root, { "data-testid": "PrintModifierKey", sx: sx, className: className, children: [_jsx(Chip, { "data-testid": "PrintModifierKeyChip", size: "small", label: modifierKey }), "+", _jsx(Chip, { "data-testid": "PrintModifierKeyChipSmall", size: "small", label: label })] }));
};
export default PrintModifierKeyAtomComponent;
